var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContacts = function SvgContacts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#3953FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0487 27.8369C31.514 28.5683 32.7702 29.742 33.6872 31.2096C33.8688 31.5003 33.9596 31.6456 33.991 31.8468C34.0548 32.2558 33.7733 32.7585 33.39 32.9204C33.2014 33 32.9892 33 32.5648 33M28.0358 23.5322C29.5271 22.7959 30.5519 21.2669 30.5519 19.5C30.5519 17.7331 29.5271 16.2041 28.0358 15.4678M26.023 19.5C26.023 21.9853 23.9953 24 21.494 24C18.9928 24 16.9651 21.9853 16.9651 19.5C16.9651 17.0147 18.9928 15 21.494 15C23.9953 15 26.023 17.0147 26.023 19.5ZM14.5086 30.9383C16.1132 28.5446 18.6452 27 21.494 27C24.3429 27 26.8749 28.5446 28.4794 30.9383C28.8309 31.4628 29.0067 31.725 28.9865 32.0599C28.9707 32.3207 28.7987 32.64 28.5889 32.7976C28.3196 33 27.9491 33 27.2082 33H15.7799C15.0389 33 14.6685 33 14.3991 32.7976C14.1894 32.64 14.0173 32.3207 14.0016 32.0599C13.9813 31.725 14.1571 31.4628 14.5086 30.9383Z",
    stroke: "#3953FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContacts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contacts.9344b57a.svg";
export { ForwardRef as ReactComponent };